import get from 'lodash/get';
import actionTypes, {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from './actionTypes';

const initialState = {
  ticmartJobs: {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
    },
    total: 0,
    sorter: {},
    filter: {},
    loading: false,
    error: null,
    selectedJobs: [],
  },
  assignedJobs: {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
    },
    total: 0,
    sorter: {
      key: '',
      value: '', // desc ||asc
    },
    loading: false,
    error: null,
  },
  jobsToAssign: {
    data: [],
  },
  modalExistingJobs: {
    data: [],
    pagination: {
      current: 1,
      pageSize: 10,
    },
    total: 0,
    sorter: {},
    filter: {},
    loading: false,
    error: null,
    selectedJobs: [],
  },
  serviceProviders: {
    data: [],
    loading: false,
    error: null,
    selectedProviders: [],
  },
  jobDetail: {
    loading: false,
    error: null,
    data: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    // #region GET_TICMART_JOBS
    case asyncActionTypeRequest(actionTypes.GET_TICMART_JOBS): {
      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_TICMART_JOBS): {
      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          total: get(action, 'response.data.pagination.total', 0),
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_TICMART_JOBS): {
      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case actionTypes.CHANGE_PARAMS_TICMART_JOBS: {
      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          pagination: {
            ...action.payload.pagination,
          },
          sorter: {
            ...action.payload.sorter,
          },
          search: {
            ...action.payload.search,
          },
          filter: {
            ...action.payload.filter,
          },
        },
      };
    }
    case actionTypes.SELECT_TICMART_JOB: {
      let tempSelectedJobs = [...state.ticmartJobs.selectedJobs];

      const findIndex = tempSelectedJobs.findIndex((x) => x.id === action.payload.selected.id);

      if (findIndex === -1) {
        tempSelectedJobs.push(action.payload.selected);
      } else {
        tempSelectedJobs.splice(findIndex, 1);
      }

      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          selectedJobs: tempSelectedJobs,
        },
      };
    }

    case actionTypes.SELECT_ALL_TICMART_JOB: {
      let tempSelectedJobs = [...state.ticmartJobs.selectedJobs];

      if (action.payload.checked) {
        const newSelectedJob = [];
        state.ticmartJobs.data.forEach((job) => {
          if (!tempSelectedJobs.find((selectedJob) => selectedJob.id === job.id)) {
            newSelectedJob.push(job);
          }
        });
        tempSelectedJobs = [...tempSelectedJobs, ...newSelectedJob];
      } else {
        state.ticmartJobs.data.forEach((job) => {
          const findIndex = tempSelectedJobs.findIndex((selectedJob) => selectedJob.id === job.id);
          if (findIndex !== -1) {
            tempSelectedJobs.splice(findIndex, 1);
          }
        });
      }

      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          selectedJobs: tempSelectedJobs,
        },
      };
    }

    case actionTypes.RESET_SELECTED_TICMART_JOB: {
      return {
        ...state,
        ticmartJobs: {
          ...state.ticmartJobs,
          selectedJobs: [],
        },
      };
    }

    // #endregion
    // #region GET_ASSIGNED_JOBS
    case asyncActionTypeRequest(actionTypes.GET_TICMART_ASSIGNED_JOBS): {
      return {
        ...state,
        assignedJobs: {
          ...state.assignedJobs,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_TICMART_ASSIGNED_JOBS): {
      return {
        ...state,
        assignedJobs: {
          ...state.assignedJobs,
          total: get(action, 'response.data.pagination.total', 0),
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_TICMART_ASSIGNED_JOBS): {
      return {
        ...state,
        assignedJobs: {
          ...state.assignedJobs,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case actionTypes.CHANGE_PARAMS_ASSIGNED_JOBS: {
      return {
        ...state,
        assignedJobs: {
          ...state.assignedJobs,
          pagination: {
            ...action.payload.pagination,
          },
          sorter: {
            ...action.payload.sorter,
          },
          search: {
            ...action.payload.search,
          },
          filter: {
            ...action.payload.filter,
          },
        },
      };
    }
    // #endregion

    // #region CHANGE_JOBS_TO_ASSIGN
    case actionTypes.CHANGE_JOBS_TO_ASSIGN: {
      return {
        ...state,
        jobsToAssign: {
          data: action.payload.jobs,
        },
      };
    }

    case actionTypes.REMOVE_JOB_TO_ASSIGN: {
      return {
        ...state,
        jobsToAssign: {
          data: state.jobsToAssign.data.filter((x) => x.id !== action.payload.jobId),
        },
      };
    }

    case actionTypes.RESET_JOB_TO_ASSIGN: {
      return {
        ...state,
        jobsToAssign: {
          data: [],
        },
      };
    }

    case asyncActionTypeRequest(actionTypes.GET_EXISTING_JOBS_MODAL): {
      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_EXISTING_JOBS_MODAL): {
      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          total: get(action, 'response.data.pagination.total', 0),
          loading: false,
          data: get(action, 'response.data.list', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_EXISTING_JOBS_MODAL): {
      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    case actionTypes.CHANGE_PARAMS_EXISTING_JOBS_MODAL: {
      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          pagination: {
            ...action.payload.pagination,
          },
          sorter: {
            ...action.payload.sorter,
          },
          search: {
            ...action.payload.search,
          },
          filter: {
            ...action.payload.filter,
          },
        },
      };
    }
    case actionTypes.RESET_PARAMS_EXISTING_JOBS_MODAL: {
      return {
        ...state,
        modalExistingJobs: {
          data: [],
          pagination: {
            current: 1,
            pageSize: 10,
          },
          total: 0,
          sorter: {
            key: '',
            value: '', // desc ||asc
          },
          search: {},
          loading: false,
          error: null,
          selectedJobs: [],
        },
      };
    }

    case actionTypes.SELECT_EXISTING_JOBS_MODAL: {
      let tempSelectedJobs = [...state.modalExistingJobs.selectedJobs];

      const findIndex = tempSelectedJobs.findIndex((x) => x.id === action.payload.selected.id);

      if (findIndex === -1) {
        tempSelectedJobs.push(action.payload.selected);
      } else {
        tempSelectedJobs.splice(findIndex, 1);
      }

      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          selectedJobs: tempSelectedJobs,
        },
      };
    }

    case actionTypes.SELECT_ALL_EXISTING_JOBS_MODAL: {
      let tempSelectedJobs = [...state.modalExistingJobs.selectedJobs];

      if (action.payload.checked) {
        const newSelectedJob = [];
        state.modalExistingJobs.data.forEach((job) => {
          if (!tempSelectedJobs.find((selectedJob) => selectedJob.id === job.id)) {
            newSelectedJob.push(job);
          }
        });
        tempSelectedJobs = [...tempSelectedJobs, ...newSelectedJob];
      } else {
        state.modalExistingJobs.data.forEach((job) => {
          const findIndex = tempSelectedJobs.findIndex((selectedJob) => selectedJob.id === job.id);
          if (findIndex !== -1) {
            tempSelectedJobs.splice(findIndex, 1);
          }
        });
      }

      return {
        ...state,
        modalExistingJobs: {
          ...state.modalExistingJobs,
          selectedJobs: tempSelectedJobs,
        },
      };
    }

    case actionTypes.SELECT_SERVICE_PROVIDER: {
      const { serviceProvider, checked } = action.payload;

      let tempServiceProvider = [...state.serviceProviders.selectedProviders];

      if (checked) {
        const isExist = tempServiceProvider.find((x) => x.id === serviceProvider.id);
        if (!isExist) {
          tempServiceProvider = [...tempServiceProvider, serviceProvider];
        }
      } else {
        tempServiceProvider = tempServiceProvider.filter((x) => x.id !== serviceProvider.id);
      }

      return {
        ...state,
        serviceProviders: {
          ...state.serviceProviders,
          selectedProviders: tempServiceProvider,
        },
      };
    }

    // #endregion

    case asyncActionTypeRequest(actionTypes.GET_SERVICE_PROVIDERS_ASSIGN_JOB): {
      return {
        ...state,
        serviceProviders: {
          ...state.serviceProviders,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_SERVICE_PROVIDERS_ASSIGN_JOB): {
      return {
        ...state,
        serviceProviders: {
          ...state.serviceProviders,
          loading: false,
          data: get(action, 'response.data', []) || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_SERVICE_PROVIDERS_ASSIGN_JOB): {
      return {
        ...state,
        serviceProviders: {
          ...state.serviceProviders,
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }

    case actionTypes.RESET_SERVICE_PROVIDER: {
      return {
        ...state,
        serviceProviders: {
          data: [],
          loading: false,
          error: null,
          selectedProviders: [],
        },
      };
    }

    case asyncActionTypeRequest(actionTypes.GET_JOB_DETAIL): {
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: true,
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(actionTypes.GET_JOB_DETAIL): {
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: false,
          data: get(action, 'response.data', {}) || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(actionTypes.GET_JOB_DETAIL): {
      return {
        ...state,
        jobDetail: {
          ...state.jobDetail,
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }

    case actionTypes.RESET_JOB_DETAIL: {
      return {
        ...state,
        jobDetail: {
          data: {},
          loading: false,
          error: null,
        },
      };
    }

    default:
      return state;
  }
};

export const REDUCER_KEY = 'ASSIGNING_JOB_BOARD';
